/** Dashboard incident tiles use the same open rules as /incidents. */

export const INCIDENT_CLOSED_STATUSES = [
  'closed',
  'resolved',
  'closed_verified',
  'completed',
  'rejected',
];

export function isOpenIncidentStatus(status) {
  const value = String(status || '').toLowerCase();
  if (!value || value === 'draft') return false;
  return !INCIDENT_CLOSED_STATUSES.includes(value);
}

export function incidentSeverityLabel(raw) {
  if (raw == null || raw === '' || raw === 'unknown') return 'Not set';
  return String(raw).replace(/_/g, ' ');
}

export function incidentBreakdownForLegend(breakdown) {
  const entries = Object.entries(breakdown || {});
  const labelled = {};
  for (const [key, count] of entries) {
    if (!count) continue;
    const label = incidentSeverityLabel(key);
    labelled[label] = (labelled[label] || 0) + count;
  }
  return labelled;
}
